<!-- Sub Header -->
<div class="subheader">
  <div class="subheader-toolbar">
    <h1>{{ title }}</h1>
<!--    @if (showBreadcrumbs) {-->
<!--      <breadcrumb [useBootstrap]="false"></breadcrumb>-->
<!--    }-->
  </div>
  <ng-content></ng-content>
</div>
